import axios from './axiosConfig'

const p = '/mcp'

export const settingsAPI = {
 getUsers: async (params?: any) => {
 const response = await axios.get(`${p}/users`, { params })
 return response.data
 },

 createUser: async (data: any) => {
 const response = await axios.post(`${p}/users`, data)
 return response.data
 },

 updateUser: async (id: number, data: any) => {
 const response = await axios.put(`${p}/users/${id}`, data)
 return response.data
 },

 deleteUser: async (id: number) => {
 const response = await axios.delete(`${p}/users/${id}`)
 return response.data
 },

 getRoles: async () => {
 const response = await axios.get(`${p}/roles`)
 return response.data
 },

 syncUserRoles: async (id: number, roles: string[]) => {
 const response = await axios.put(`${p}/users/${id}/roles`, { roles })
 return response.data
 },
}
